var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"anonymity-query"},[_c('a-page-header',{staticStyle:{"padding":"0"},attrs:{"subTitle":"串号查询"},on:{"back":function($event){return _vm.$router.go(-1)}}}),_c('my-list',{attrs:{"dataSource":_vm.dataSource,"loading":_vm.loading,"btnConfig":['查看证书','查看二维码','查看文件']}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }